import { render } from "./PixelArtPlace.vue?vue&type=template&id=09d20e2a&scoped=true"
import script from "./PixelArtPlace.vue?vue&type=script&lang=js"
export * from "./PixelArtPlace.vue?vue&type=script&lang=js"

import "./PixelArtPlace.vue?vue&type=style&index=0&id=09d20e2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d20e2a"]])

export default __exports__